/*
 * @Author: your name
 * @Date: 2020-08-14 10:06:51
 * @LastEditTime: 2020-08-14 16:57:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \新建文件夹 (2)\src\router\login.js
 */
import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/index'

Vue.use(Router)
const loginRouter =[
  {
    path: '/loginBySupervise',
    component: () => import('@/views/login/login2'),
    name: 'login2'
  },
  // {
  //   path: '/loginByCorp',
  //   component: () => import('@/views/login/login3'),
  //   name: 'login3'
  // },
  // {
  //   path: '/loginByUser',
  //   component: () => import('@/views/login/login4'),
  //   name: 'login4'
  // },
  {
    path: '/loginByCorp',
    component: () => import('@/views/login/loginqiye'),
    name: 'loginqiye'
  },
  {
    path: '/loginByUser',
    component: () => import('@/views/login/loginyonghu'),
    name: 'loginyonghu'
  },
  {
    path: '/',
    component: Layout,
    children: [
    {
      path: '/login',
      component: () => import('@/views/login/login'),//用户登录
      name: 'login'
    },
    // {
    //   path: '/login2',
    //   component: () => import('@/views/login/login2'),
    //   name: 'login2'
    // },
    {
      path: '/user-findPwd',
      component: () => import('@/views/login/user-findPwd'),//个人用户找回密码
      name: 'user-findPwd'
    },
    {
      path: '/company-findPwd',
      component: () => import('@/views/login/company-findPwd'),//企业号找回密码
      name: 'company-findPwd'
    },
    {
      path: '/register',
      component: () => import('@/views/login/register'),//注册页
      name: 'register'
    }
    ]
	}
]

export default loginRouter



// WEBPACK FOOTER //
// ./src/router/login.js